@let job = (job$ |async);

@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="job-page" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    @if(job){
    <app-progress-job-counter [job]="job" />
    }
    @if(job && job.waitingResponseTask){
    <app-button [routerLink]="[ 'video-editing',job.waitingResponseTask.id]" type="waiting-response">{{
        'job_detail.buttons.edit_levels' | translate }}</app-button>
    }@else if (job && job.completed) {
    <app-button [disabled]="videoLoading" class="download-btn" (onClick)="downloadVideo()">
        <lucide-angular name="download" size="16" strokeWidth="2" />
        {{ 'job_detail.buttons.download_video' | translate }}
    </app-button>
    <app-button [disabled]="audioLoading" class="download-btn" (onClick)="downloadAudio()">
        <lucide-angular name="download" size="16" strokeWidth="2" />
        {{ 'job_detail.buttons.download_audio' | translate }}
    </app-button>
    }
    <p class="information">{{job?.currentTask?.message || job?.currentTask?.type || 'no messages'}}</p>

    @if(smallScreen && job){
    <div class="stepper-wrapper">
        <app-stepper [tasks]="job.tasks"></app-stepper>
    </div>

    } @else if(job){
    <app-horizontal-stepper [job]="job"></app-horizontal-stepper>
    }
    <app-button type="discreet" (onClick)="moreInfoVisible = !moreInfoVisible">{{'common.more_info' |
        translate}}</app-button>
    @if(moreInfoVisible){
    <ul class="job-details">
        @for(detail of jobDetails; track $index){
        <li>
            <p class="label">{{detail.label | translate | titlecase}} :</p>
            <p class="value">{{detail.value | translate}}</p>
        </li>
        }
    </ul>
    <app-button type="danger" (onClick)="modalService.openDeleteJobModal((job!.id))">{{ 'job_detail.buttons.delete_job'
        | translate
        }}</app-button>
    }
</div>